import { render, staticRenderFns } from "./ZabbixConfig.vue?vue&type=template&id=b88e6624"
import script from "./ZabbixConfig.vue?vue&type=script&lang=js"
export * from "./ZabbixConfig.vue?vue&type=script&lang=js"
import style0 from "./ZabbixConfig.vue?vue&type=style&index=0&id=b88e6624&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports